var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.3269 15.3835L21 22.0566M16.68 9.78348C16.68 14.1134 13.1699 17.6235 8.84 17.6235C4.51009 17.6235 1 14.1134 1 9.78348C1 5.45357 4.51009 1.94348 8.84 1.94348C13.1699 1.94348 16.68 5.45357 16.68 9.78348Z",
    stroke: "#A9A9AE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilter);
export default __webpack_public_path__ + "static/media/search-filter.90c82a2bc338f950c45dea1e8fbeb75c.svg";
export { ForwardRef as ReactComponent };